import React from 'react'

import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {Loader} from '../../utils/misc'
export default class AddBrand extends React.Component {

  constructor(props) {
    super(props)
    this.state = { brand: {name:"", code:"", notes:""}, loading:true}
    this.handleInputChange = this.handleInputChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getBrand = this.getBrand.bind(this)
    this.deleteBrand = this.deleteBrand.bind(this)
  }

  deleteBrand() {
    axios({
      url: '/delete_brand/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.brand
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Brand successfully")
        setTimeout(()=>{
          this.props.history.push("/brands/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }

  componentDidMount() {

    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.brand_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Brand " + this.props.match.params.brand_id
      this.getBrand(this.props.match.params.brand_id).then((response)=>{
        if(response.status===200) {
          this.setState({brand: response.data.brand, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }

    else {
        document.title = "Create Brand "
        this.setState({loading:false})
    }

  }

  getBrand(brand_id) {
    return axios({
      url: '/get_brand/?id='+brand_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  submit() {
    this.setState({submitting:true})


    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_brand/"
    }
    else {
      apiurl  = "/create_new_brand/"
    }


    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.brand
    }).then((response)=> {
      if(response.status === 200) {

        this.setState({brand:response.data.brand, submitting:false})
        if(typeof this.props.onAddCallback !== "undefined") {
          this.props.onAddCallback(response.data.brand)
        }
        else {

          if(this.state.mode==="edit") {
            NotificationManager.success("Updated Brand successfully")
          }
          else {
            NotificationManager.success("Created Brand successfully")
          }

          setTimeout(()=>{
            this.props.history.push("/brands/")
          }, 700)
        }

      }
    }).catch((err)=> {
      console.log(err);
      this.setState({submitting:false})
    })

  }

  handleInputChange(e) {
    var name = e.target.name
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    let brand = this.state.brand
    brand[name] = value
    this.setState({brand:brand})
  }



  render() {


    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>
    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }


    if(this.state.loading) {
      return <Loader />
    }
    else {

        let brand = this.state.brand
        let pageHeader, deleteBrandBtn, hideBrandField
        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Brand  #" + brand.id}</h3>
          deleteBrandBtn = <button className="btn btn-danger" onClick={this.deleteBrand}>Delete Brand</button>
          hideBrandField = <div className="form-group">
              <label className="col-sm-4 text-right">Hide Brand</label>
            <div className="col-sm-8">
              <input type="checkbox" name="is_hidden" checked={brand.is_hidden} onChange={this.handleInputChange} /> This will hide items from the item list.
            </div>
          </div>
        }
        else {
          pageHeader =  <h3 >Create New Brand</h3>
        }

        let form = <div className='form-horizontal'>
                  <div className="form-group">
                    <label className="col-sm-4 text-right">Name <span>*</span></label>
                    <div className="col-sm-8">
                    <input type="text" name="name" className="form-control" value={brand.name} onChange={this.handleInputChange} required/>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 text-right">Code</label>
                    <div className="col-sm-8">
                    <input type="text" name="code" className="form-control" value={brand.code} onChange={this.handleInputChange}/>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 text-right">Notes</label>
                    <div className="col-sm-8">
                    <textarea name="notes" className="form-control" value={brand.notes} onChange={this.handleInputChange}></textarea>
                    </div>
                  </div>
                  {hideBrandField}
                  <div className="form-action-group text-center">
                  {submitButton}
                  </div>

              </div>

      return <div>
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li className="pull-right">{deleteBrandBtn}</li>
              </ul>
        </section>
          {form}
      </div>
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/brand/addbrand.js